/**
 * Значки нарисованы здесь, а не взяты из набора Apple: SF Symbols лицензируются
 * только для платформ Apple, в вебе они запрещены. Обычные SVG свободны.
 */

export function TruckIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M2 16V7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v9" />
      <path d="M14 10h3.6a1 1 0 0 1 .82.43l2.4 3.4a1 1 0 0 1 .18.57V16" />
      <circle cx="7" cy="17.5" r="1.9" />
      <circle cx="17.5" cy="17.5" r="1.9" />
      <path d="M9 17.5h6.5M2 16h3" />
    </svg>
  )
}

export function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="4" y="10.5" width="16" height="10" rx="2" />
      <path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" />
    </svg>
  )
}

/** Значки вкладок. Рисуются в одной сетке 24×24 с одной толщиной линии,
    иначе в полосе внизу они выглядят набранными из разных наборов. */

export function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M18 9a6 6 0 1 0-12 0c0 5-2 6.5-2 6.5h16S18 14 18 9" />
      <path d="M13.7 19a2 2 0 0 1-3.4 0" />
    </svg>
  )
}

export function ChartIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
    </svg>
  )
}

export function GearIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="3.1" />
      <path d="M19.4 14.5a1.6 1.6 0 0 0 .32 1.77l.06.06a1.9 1.9 0 1 1-2.7 2.7l-.05-.06a1.6 1.6 0 0 0-1.78-.32 1.6 1.6 0 0 0-1 1.47V20a1.9 1.9 0 1 1-3.8 0v-.1a1.6 1.6 0 0 0-1.05-1.46 1.6 1.6 0 0 0-1.77.32l-.06.06a1.9 1.9 0 1 1-2.7-2.7l.06-.05a1.6 1.6 0 0 0 .32-1.78 1.6 1.6 0 0 0-1.47-1H4a1.9 1.9 0 1 1 0-3.8h.1a1.6 1.6 0 0 0 1.46-1.05 1.6 1.6 0 0 0-.32-1.77l-.06-.06a1.9 1.9 0 1 1 2.7-2.7l.05.06a1.6 1.6 0 0 0 1.78.32H10a1.6 1.6 0 0 0 1-1.47V4a1.9 1.9 0 1 1 3.8 0v.1a1.6 1.6 0 0 0 1 1.47 1.6 1.6 0 0 0 1.78-.32l.06-.06a1.9 1.9 0 1 1 2.7 2.7l-.06.05a1.6 1.6 0 0 0-.32 1.78V10a1.6 1.6 0 0 0 1.47 1H20a1.9 1.9 0 1 1 0 3.8h-.1a1.6 1.6 0 0 0-1.47 1z" />
    </svg>
  )
}

/** Здание: вкладка «Компании» — она в той же полосе, но отдельна от
    шестерёнки управления, чтобы две вкладки администратора не сливались
    в одну на вид. */
export function BuildingIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 21V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16" />
      <path d="M14 10h4a1 1 0 0 1 1 1v10" />
      <path d="M2 21h20" />
      <path d="M7.5 7.5h1M11.5 7.5h1M7.5 11h1M11.5 11h1M7.5 14.5h1M11.5 14.5h1M17.5 14.5h1M17.5 18h1" />
    </svg>
  )
}

/** Значки кнопок поверх карты. Та же сетка 24×24, что и у вкладок. */

/**
 * Прицел: вернуться к выбранной машине.
 *
 * Перекрестье с разрывами, а не сплошной крест: сплошной в кружке
 * читается как запрещающий знак.
 */
export function CrosshairIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="7" />
      <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
    </svg>
  )
}

/**
 * Стрелка «где я». Намеренно не перекрестье: перекрестье уже занято
 * прицелом, а две кнопки-близнеца рядом не различишь и на второй раз.
 */
export function LocateIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 3 3 10.2a.6.6 0 0 0 .05 1.13l7.4 2.42a.6.6 0 0 1 .38.38l2.42 7.4a.6.6 0 0 0 1.13.05z" />
    </svg>
  )
}
